/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CaseFileZipTaskStatus,
    CaseFileZipTaskStatusFromJSON,
    CaseFileZipTaskStatusFromJSONTyped,
    CaseFileZipTaskStatusToJSON,
    ZipUrl,
    ZipUrlFromJSON,
    ZipUrlFromJSONTyped,
    ZipUrlToJSON,
} from './';

/**
 * 
 * @export
 * @interface CaseFileZipView
 */
export interface CaseFileZipView {
    /**
     * 
     * @type {string}
     * @memberof CaseFileZipView
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileZipView
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFileZipView
     */
    caseId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileZipView
     */
    createdDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CaseFileZipView
     */
    modifiedDate?: Date | null;
    /**
     * 
     * @type {CaseFileZipTaskStatus}
     * @memberof CaseFileZipView
     */
    status?: CaseFileZipTaskStatus;
    /**
     * 
     * @type {number}
     * @memberof CaseFileZipView
     */
    progressPercentage?: number;
    /**
     * 
     * @type {Array<ZipUrl>}
     * @memberof CaseFileZipView
     */
    zipUrls?: Array<ZipUrl> | null;
}

export function CaseFileZipViewFromJSON(json: any): CaseFileZipView {
    return CaseFileZipViewFromJSONTyped(json, false);
}

export function CaseFileZipViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFileZipView {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'caseId': !exists(json, 'caseId') ? undefined : json['caseId'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'status': !exists(json, 'status') ? undefined : CaseFileZipTaskStatusFromJSON(json['status']),
        'progressPercentage': !exists(json, 'progressPercentage') ? undefined : json['progressPercentage'],
        'zipUrls': !exists(json, 'zipUrls') ? undefined : (json['zipUrls'] === null ? null : (json['zipUrls'] as Array<any>).map(ZipUrlFromJSON)),
    };
}

export function CaseFileZipViewToJSON(value?: CaseFileZipView | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'userId': value.userId,
        'caseId': value.caseId,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate === null ? null : value.modifiedDate.toISOString()),
        'status': CaseFileZipTaskStatusToJSON(value.status),
        'progressPercentage': value.progressPercentage,
        'zipUrls': value.zipUrls === undefined ? undefined : (value.zipUrls === null ? null : (value.zipUrls as Array<any>).map(ZipUrlToJSON)),
    };
}


